import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tankListing: {
    loading: false,
    error: null,
    data: null,
  },
  tankDetails: {
    loading: false,
    error: null,
    data: null,
  },
  tankLevel: {
    loading: false,
    error: null,
    data: null,
  },
  tankLevelHistory: {
    loading: false,
    error: null,
    data: null,
  },
  createTank: {
    loading: false,
    error: null,
    data: null,
  },
  updateTank: {
    loading: false,
    error: null,
    data: null,
  },
  deleteTank: {
    loading: false,
    error: null,
    data: null,
  },
};

const tanksSlice = createSlice({
  name: "tanks",
  initialState,
  reducers: {
    // Tank Listing
    tankListingStart: (state) => {
      state.tankListing.loading = true;
      state.tankListing.error = null;
    },
    tankListingSuccess: (state, action) => {
      state.tankListing.loading = false;
      state.tankListing.data = action.payload;
      state.tankListing.error = null;
    },
    tankListingFailure: (state, action) => {
      state.tankListing.loading = false;
      state.tankListing.error = action.payload;
    },
    tankListingReset: (state) => {
      state.tankListing = initialState.tankListing;
    },

    // Tank Details
    tankDetailsStart: (state) => {
      state.tankDetails.loading = true;
      state.tankDetails.error = null;
    },
    tankDetailsSuccess: (state, action) => {
      state.tankDetails.loading = false;
      state.tankDetails.data = action.payload;
      state.tankDetails.error = null;
    },
    tankDetailsFailure: (state, action) => {
      state.tankDetails.loading = false;
      state.tankDetails.error = action.payload;
    },
    tankDetailsReset: (state) => {
      state.tankDetails = initialState.tankDetails;
    },

    // Tank Current Level
    tankLevelStart: (state) => {
      state.tankLevel.loading = true;
      state.tankLevel.error = null;
    },
    tankLevelSuccess: (state, action) => {
      state.tankLevel.loading = false;
      state.tankLevel.data = action.payload;
      state.tankLevel.error = null;
    },
    tankLevelFailure: (state, action) => {
      state.tankLevel.loading = false;
      state.tankLevel.error = action.payload;
    },

    // Tank Level History
    tankLevelHistoryStart: (state) => {
      state.tankLevelHistory.loading = true;
      state.tankLevelHistory.error = null;
    },
    tankLevelHistorySuccess: (state, action) => {
      state.tankLevelHistory.loading = false;
      state.tankLevelHistory.data = action.payload;
      state.tankLevelHistory.error = null;
    },
    tankLevelHistoryFailure: (state, action) => {
      state.tankLevelHistory.loading = false;
      state.tankLevelHistory.error = action.payload;
    },

    // Create Tank
    createTankStart: (state) => {
      state.createTank.loading = true;
      state.createTank.error = null;
      state.createTank.data = null;
    },
    createTankSuccess: (state, action) => {
      state.createTank.loading = false;
      state.createTank.data = action.payload;
      state.createTank.error = null;
    },
    createTankFailure: (state, action) => {
      state.createTank.loading = false;
      state.createTank.error = action.payload;
    },
    createTankReset: (state) => {
      state.createTank = initialState.createTank;
    },

    // Update Tank
    updateTankStart: (state) => {
      state.updateTank.loading = true;
      state.updateTank.error = null;
      state.updateTank.data = null;
    },
    updateTankSuccess: (state, action) => {
      state.updateTank.loading = false;
      state.updateTank.data = action.payload;
      state.updateTank.error = null;
    },
    updateTankFailure: (state, action) => {
      state.updateTank.loading = false;
      state.updateTank.error = action.payload;
    },
    updateTankReset: (state) => {
      state.updateTank = initialState.updateTank;
    },

    // Delete Tank
    deleteTankStart: (state) => {
      state.deleteTank.loading = true;
      state.deleteTank.error = null;
      state.deleteTank.data = null;
    },
    deleteTankSuccess: (state, action) => {
      state.deleteTank.loading = false;
      state.deleteTank.data = action.payload;
      state.deleteTank.error = null;
    },
    deleteTankFailure: (state, action) => {
      state.deleteTank.loading = false;
      state.deleteTank.error = action.payload;
    },
    deleteTankReset: (state) => {
      state.deleteTank = initialState.deleteTank;
    },
  },
});

export const {
  tankListingStart,
  tankListingSuccess,
  tankListingFailure,
  tankListingReset,
  tankDetailsStart,
  tankDetailsSuccess,
  tankDetailsFailure,
  tankDetailsReset,
  tankLevelStart,
  tankLevelSuccess,
  tankLevelFailure,
  tankLevelHistoryStart,
  tankLevelHistorySuccess,
  tankLevelHistoryFailure,
  createTankStart,
  createTankSuccess,
  createTankFailure,
  createTankReset,
  updateTankStart,
  updateTankSuccess,
  updateTankFailure,
  updateTankReset,
  deleteTankStart,
  deleteTankSuccess,
  deleteTankFailure,
  deleteTankReset,
} = tanksSlice.actions;

export default tanksSlice.reducer;
